import { CharTypeId } from "rl-common/consts";
import { RevisionStatus } from "rl-common/services/entity-config/entity-config.models";

export interface RevisionStatusMeta {
	displayName: string;
	value: number;
	charTypes: number[];
}

export namespace RevisionStatusUtil {
	export const RevisionStatusLookup: { [key in RevisionStatus]: RevisionStatusMeta } = {
		[RevisionStatus.InSetup]: {
			displayName: "In Setup",
			value: 1,
			charTypes: [CharTypeId.All]
		},
		[RevisionStatus.Complete]: {
			displayName: "Complete",
			value: 2,
			charTypes: [CharTypeId.All]
		},
		[RevisionStatus.Approved]: {
			displayName: "Approved",
			value: 3,
			charTypes: [CharTypeId.All]
		},
		[RevisionStatus.InRevision]: {
			displayName: "In Revision",
			value: 4,
			charTypes: [CharTypeId.All]
		},
		[RevisionStatus.FinancialDocComplete]: {
			displayName: "Complete",
			value: 5,
			charTypes: [CharTypeId.Invoice]
		},
		[RevisionStatus.FinancialDocPosted]: {
			displayName: "Posted",
			value: 6,
			charTypes: [CharTypeId.Invoice]
		},
		[RevisionStatus.FinancialDocCleared]: {
			displayName: "Cleared",
			value: 7,
			charTypes: [CharTypeId.Invoice]
		},
		[RevisionStatus.Paid]: {
			displayName: "Paid",
			value: 8,
			charTypes: [CharTypeId.Invoice]
		},
		[RevisionStatus.Release]: {
			displayName: "Release",
			value: 9,
			charTypes: [CharTypeId.Invoice]
		},
		[RevisionStatus.Hold]: {
			displayName: "Hold",
			value: 10,
			charTypes: [CharTypeId.Invoice]
		}
	};

	export function toDisplayName(revisionStatus: RevisionStatus) {
		return RevisionStatusLookup[revisionStatus].displayName;
	}
}
